import React, { useState } from "react";
import Header from "../../components/Header/Header";
import filter from "../../assets/filter_list.svg";
import VSFilter from "../../components/Modals/VSFilter";
import Footer from "../../components/Footer/Footer";
import { useInterceptor } from "providers/InterceptorProvider";
import { useEffect } from "react";
import { useUser } from "providers/UserProvider";
import { format, addMonths } from "date-fns";

const Dashboard = () => {
  const { api } = useInterceptor();
  const { user } = useUser();
  const lastMonth = addMonths(new Date(), -1);
  const [showVSFilter, setShowVSFilter] = useState(false);
  const [totalPage, setTotalPage] = useState([]);
  const [vsfilter, setVSFilter] = useState([]);
  const [activityFilter, setActivityFilter] = useState([]);
  const [functionFilter, setFunctionFilter] = useState([]);
  const [availableDates, setAvailableDates] = useState([]);
  const [tablePage, setTablePage] = useState([1, 1, 1]);
  const [dateFilter, setDateFilter] = useState(format(lastMonth, "yyyyMM"));
  const [data, setData] = useState([]);

  const extractAvailableDates = (
    vsResponse,
    activityResponse,
    functionalResponse
  ) => {
    const months = [
      ...new Set(
        [
          vsResponse?.data?.uniqueMonths,
          activityResponse?.data?.uniqueMonths,
          functionalResponse?.data?.uniqueMonths,
          [format(lastMonth, "yyyyMM")],
        ].flat()
      ),
    ]
      .filter((month) => Boolean(month))
      .map((month) => {
        console.log(month);
        const formattedDate = format(
          new Date(`${month.slice(0, 4)}-${month.slice(4)}-01`),
          "MMM, yy"
        );

        return {
          month,
          formattedDate,
        };
      });

    months.sort((firstMonth, secondMonth) =>
      firstMonth.month.localeCompare(secondMonth.month)
    );

    if (months > availableDates) {
      setAvailableDates(months);
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        let vsFilterQuery = "";
        let activityFilterQuery = "";
        let functionFilterQuery = "";
        if (vsfilter.length !== 0) {
          // alert("value stream");
          vsFilterQuery =
            vsfilter.length > 0 ? `&valueStream=${vsfilter.join(",")}` : "";
        }
        if (activityFilter.length !== 0) {
          // alert("activity");
          activityFilterQuery =
            activityFilter.length > 0
              ? `&subActivityFilter=${activityFilter.join(",")}`
              : "";
        }
        if (functionFilter.length !== 0) {
          // alert("function");
          functionFilterQuery =
            functionFilter.length > 0
              ? `&functionFilter=${functionFilter.join(",")}`
              : "";
        }
        let date = "";
        if (dateFilter) {
          date = `?date=${dateFilter}`;
        }
        // console.log("date => ", date);

        const [vsResponse, activityResponse, functionalResponse] =
          await Promise.all([
            api.get(
              `/dashboard/value-stream-data/${user.organizationId}/${tablePage[0]}${date}${vsFilterQuery}`
            ),
            api.get(
              `/dashboard/activity-data/${user.organizationId}/${tablePage[1]}${date}${activityFilterQuery}`
            ),
            api.get(
              `/dashboard/function-data/${user.organizationId}/${tablePage[2]}${date}${functionFilterQuery}`
            ),
          ]);

        const newData = [
          vsResponse?.data?.data || [],
          activityResponse?.data?.data || [],
          functionalResponse?.data?.data || [],
        ];
        setTotalPage([
          vsResponse.data.length,
          activityResponse.data.length,
          functionalResponse.data.length,
        ]);
        setData(newData);

        extractAvailableDates(vsResponse, activityResponse, functionalResponse);
      } catch (err) {
        console.error("error from dashboard UI,", err);
      }
    }
    if (user?.organizationId) {
      fetchData();
    }
  }, [user, tablePage, vsfilter, activityFilter, functionFilter, dateFilter]);

  const handleFilterApply = (data, table) => {
    if (table === "Value-Stream") {
      setVSFilter(data);
    } else if (table === "Activity") {
      setActivityFilter(data);
    } else {
      setFunctionFilter(data);
    }
    setShowVSFilter(false);
  };

  const title = ["Value-Stream", "Activity", "Department"];
  return (
    <div className="">
      {/* min-[1500px]:flex min-[1500px]:flex-col min-[1500px]:justify-center min-[1500px]:items-center */}
      <Header
        availableDates={availableDates}
        defaultMonth={format(lastMonth, "MMM, yy")}
        setDateFilter={setDateFilter}
        setTablePage={setTablePage}
      />

      {/* section 1 */}
      {data.map((table, index) => (
        <section
          key={index}
          className="mx-auto mt-6 font-inter max-w-[1200px] max-xl:px-5"
        >
          <div className="flex justify-between items-center">
            <h3 className="text-[18px] font-[600]">{title[index]} KPIs</h3>
            <button
              className="flex gap-2 items-center border border-[#E5E5E5] px-3 py-1 rounded-[6px]"
              onClick={() => setShowVSFilter(title[index])}
            >
              <img src={filter} alt="" className="" />
              <span className="">Filter</span>
            </button>
            {showVSFilter === title[index] && (
              <VSFilter
                onApply={handleFilterApply}
                table={title[index]}
                filterData={
                  title[index] === "Value-Stream"
                    ? vsfilter
                    : title[index] === "Activity"
                    ? activityFilter
                    : functionFilter
                }
              />
            )}
          </div>
          <div className="overflow-hidden rounded-[10px] border-[1.5px] border-[#D9D9D9] w-full mt-2">
            <div className="overflow-x-auto">
              <table className="w-full min-w-max">
                <thead className="">
                  <tr className="border-b-[1.5px] border-[#D9D9D9] bg-[#F5F5F5]">
                    <th className="px-9 py-3 text-left text-xs font-bold text-gray-900 rounded-tl-[10px]">
                      {title[index]}
                    </th>
                    <th className="px-9 py-3 text-left text-xs font-bold text-gray-900">
                      KPIs
                    </th>
                    <th className="px-9 py-3 text-center text-xs font-bold text-gray-900">
                      Vs. Prior Period
                    </th>
                    <th className="px-9 py-3 text-center text-xs font-bold text-gray-900">
                      Vs. Average
                    </th>
                    <th className="px-9 py-3 text-center text-xs font-bold text-gray-900">
                      Vs. Target
                    </th>
                    <th className="pl-9 pr-4 py-3 text-center text-xs font-bold text-gray-900 rounded-tr-[10px]">
                      Health
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y-[1.5px] divide-[#D9D9D9]">
                  {table.length > 0 ? (
                    table?.map((kpi, kpiIndex) => (
                      <tr
                        key={kpiIndex}
                        className={
                          kpiIndex % 2 === 0
                            ? "bg-white"
                            : "bg-[#F5F5F5] bg-opacity-40"
                        }
                      >
                        <td
                          className={`px-9 py-2.5 text-xs text-gray-900 ${
                            index === kpi?.length - 1 ? "rounded-bl-[10px]" : ""
                          }`}
                        >
                          {kpi.nodeName}
                        </td>
                        <td className="px-9 py-2.5 text-xs text-gray-900">
                          {kpi.KPIname}
                        </td>
                        <td className="px-9 py-2.5">
                          <div className="flex justify-center">
                            <div
                              className={`w-2 h-2 rounded-[2px] ${
                                kpi?.KPIdata?.vsPriorPeriod === "LOSS"
                                  ? "bg-red-500"
                                  : "bg-green-500"
                              }`}
                            />
                          </div>
                        </td>
                        <td className="px-9 py-2.5">
                          <div className="flex justify-center">
                            <div
                              className={`w-2 h-2 rounded-[2px] ${
                                kpi?.KPIdata?.vsAverage === "LOSS"
                                  ? "bg-red-500"
                                  : "bg-green-500"
                              }`}
                            />
                          </div>
                        </td>
                        <td className="px-9 py-2.5">
                          <div className="flex justify-center">
                            <div
                              className={`w-2 h-2 rounded-[2px] ${
                                kpi?.KPIdata?.vsTarget === "LOSS"
                                  ? "bg-red-500"
                                  : "bg-green-500"
                              }`}
                            />
                          </div>
                        </td>
                        <td
                          className={`pl-9 pr-4 py-2.5 ${
                            index === kpi?.length - 1 ? "rounded-br-[10px]" : ""
                          }`}
                        >
                          <div className="flex justify-center">
                            <div
                              className={`bg-opacity-5 text-center rounded-[4px] py-0.5 font-semibold text-[10px] w-[64px] border ${
                                kpi?.KPIdata?.health === "RED"
                                  ? "bg-[#E32304] bg-opacity-5 border-[#E32304] border-opacity-15 text-[#E32304]"
                                  : kpi?.KPIdata?.health === "GREEN"
                                  ? "bg-[#5ED376] bg-opacity-5 border-[#5ED376] border-opacity-15 text-[#55C880]"
                                  : "bg-[#E9B704] bg-opacity-5 border-[#E9B704] border-opacity-15 text-[#E9B704]"
                              }`}
                            >
                              {kpi?.KPIdata?.health?.toUpperCase()}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="">
                      <td
                        colSpan="6"
                        className="text-center text-gray-500 py-12"
                      >
                        There are no KPIs to be shown.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* pagination */}
          {data[index].length > 0 && (
            <div className="w-full py-2 flex items-center justify-between font-inter">
              <div className="text-xs text-gray-700 font-medium">
                Showing {(tablePage[index] - 1) * 5 + 1} to{" "}
                {totalPage[index] < tablePage[index] * 5
                  ? totalPage[index]
                  : tablePage[index] * 5}{" "}
                of {totalPage[index]}
              </div>
              <div className="flex gap-1 items-center">
                <div className="flex items-center">
                  <button
                    className="p-2"
                    aria-label="Previous"
                    onClick={() => {
                      if (tablePage[index] !== 1) {
                        setTablePage((prevArray) => {
                          const newArray = [...prevArray];
                          newArray[index] = newArray[index] - 1;
                          return newArray;
                        });
                      }
                    }}
                  >
                    <svg
                      className="h-5 w-5 text-gray-400"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
                {Array.from(
                  { length: Math.ceil(totalPage[index] / 5) },
                  (_, i) => i + 1
                ).map((pageNumber) => (
                  <div
                    key={pageNumber}
                    className={`px-3 py-1.5 text-xs rounded cursor-pointer ${
                      tablePage[index] === pageNumber
                        ? "bg-[#1C3F3A] text-white"
                        : "text-black"
                    }`}
                    onClick={() =>
                      setTablePage((prevArray) => {
                        const newArray = [...prevArray];
                        newArray[index] = pageNumber;
                        return newArray;
                      })
                    }
                  >
                    {pageNumber}
                  </div>
                ))}
                <div className="flex items-center">
                  <button
                    className="p-2"
                    aria-label="Next"
                    onClick={() => {
                      if (
                        tablePage[index] !== Math.ceil(totalPage[index] / 5)
                      ) {
                        setTablePage((prevArray) => {
                          const newArray = [...prevArray];
                          newArray[index] = newArray[index] + 1;
                          return newArray;
                        });
                      }
                    }}
                  >
                    <svg
                      className="h-5 w-5 text-gray-400"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          )}
        </section>
      ))}
      <Footer />
    </div>
  );
};

export default Dashboard;
